<script>
  import * as restfulService from '../../../services/restfulService'

  import helpers from '@mixins/helper'

  import {required} from 'vuelidate/lib/validators'

  import NavigationButtons from './NavigationButtons'

  import bus from '@utils/bus'

  export default {
    mixins: [helpers],
    components: {NavigationButtons},
    name: 'financeiro',
    props: {
      dados: {
        required: true,
        type: Object,
        default: () => ({})
      },
      etapaAtiva: {
        type: Number,
        required: true
      },
      desabilita: {
        type: Object,
        default: () => ({})
      }
    },
    data () {
      return {
        parcelasDisponiveis: [],
        incentivos: [],
        intencaoVaga: '',
        descontoAVista: ''
      }
    },
    computed: {
      dadosMatricula: {
        get () {
          return this.dados
        },
        set (value) {
          this.$emit('update:dados', value)
        }
      },
      parcelaSelecionada () {
        if (this.parcelasDisponiveis.length) {
          this.dados.matricula.parcelas = this.parcelasDisponiveis.find(item => item.quantidade === this.dadosMatricula.matricula.parcelamento)
          return this.dados.matricula.parcelas
        }

        return {}
      }
    },
    validations: {
      dadosMatricula: {
        matricula: {
          parcelamento: {required}
        }
      }
    },
    watch: {
      etapaAtiva (value) {
        if (value === 4) {
          this.carregaValoresCurriculo()
        }
      }
    },
    methods: {
      async carregaValoresCurriculo () {
        bus.$emit('show-loader')
        await restfulService.get('matricula-online/financeiro/' + this.dados.matricula.ref_contrato + '/' + this.dados.matricula.ref_curriculo)
          .then(response => {
            this.parcelasDisponiveis = response.parcelas
            this.incentivos = response.incentivos
            this.intencaoVaga = response.intencaoVaga
            this.descontoAVista = response.descontoAVista
            this.carregandoDados = false
            this.dadosMatricula.matricula.parcelamento = this.parcelasDisponiveis.reduce((numeroParcela, item) => { return numeroParcela > item.quantidade ? numeroParcela : item.quantidade }, '')
            this.dadosMatricula.matricula.incentivos = response.incentivos
            this.dadosMatricula.matricula.intencaoVaga = response.intencaoVaga
          })
          .catch(e => {
            console.log(e)
          })
        bus.$emit('hide-loader')
      },
      salvarDados () {
        this.desabilita.aba4 = true
        this.desabilita.aba5 = false
        this.$emit('update:etapaAtiva', (this.etapaAtiva + 1))
        this.$emit('update:desabilita', this.desabilita)
      },
      voltar () {
        this.desabilita.aba3 = false
        this.desabilita.aba4 = true
        this.$emit('update:etapaAtiva', (this.etapaAtiva - 1))
        this.$emit('update:desabilita', this.desabilita)
      }
    }
  }
</script>

<template>
    <v-container fluid grid-list-md ma-0 pa-0>
        <template>

          <div v-if="intencaoVaga.intencao">
            <h4 class="title mb-3">Intenção de vaga:</h4>
            <v-alert :value="true" type="warning">
              <template v-for="mensagem in intencaoVaga.mensagem">{{mensagem}}<br></template>
            </v-alert>
          </div>

          <div v-else-if="incentivos.length">
            <h4 class="title mb-3">Você possui incentivos ativos:</h4>
            <v-alert :value="true" type="info">
              <template v-for="item in incentivos">
                {{item}}<br>
              </template>
              ATENÇÃO: Caso não concorde com os valores impressos, não conclua sua pré-matrícula e entre em contato com a Central de Atendimento.
            </v-alert>
          </div>

          <div v-else>
            <v-alert :value="true" type="warning">
              Você não possui incentivos (FIES, PROUNI, etc). Caso não concorde, não conclua sua pré-matrícula e entre em contato com a Central de Atendimento.
            </v-alert>
          </div>

        </template>

        <v-layout row wrap>
            <v-flex xs12>
                <h4 class="title mb-3">Formas de pagamento:</h4>

                <v-radio-group v-model="dadosMatricula.matricula.parcelamento">
                    <v-radio
                      v-for="(item, index) in parcelasDisponiveis"
                      :key="index"
                      :value="item.quantidade"
                    >
                    <template slot="label" v-if="item.quantidade > 1">
                      <template v-for="parcela in item.detalhes">
                        <span v-if="parcela.numeroParcela == 1">
                        <strong>{{parcela.numeroParcela}}x</strong> de R$ {{parcela.valorUnitario | currencyEnToBr}} + <strong>{{item.quantidade -1}}x</strong> de R$ {{item.valor | currencyEnToBr}}
                        </span>
                      </template>
                    </template>
                    <template slot="label" v-if="item.quantidade == 1">
                      <strong>{{item.quantidade}}x</strong>&nbsp;de R$ {{item.valor | currencyEnToBr}}
                      <span v-if="item.textoAdicional">&nbsp;({{item.textoAdicional}})</span>
                      <span v-if="item.quantidade===1 && !intencaoVaga.intencao">&nbsp;(com desconto de antecipação de {{descontoAVista}}%)</span>
                    </template>

                  </v-radio>
                </v-radio-group>

                <h4 class="title mt-4 mb-3">Dados dos Pagamentos</h4>
                <table class="v-datatable v-table theme--light" v-if="parcelaSelecionada">
                    <thead>
                    <tr>
                        <th>Parcela</th>
                        <th>Data de Vencimento</th>
                        <th>Valor</th>
                        <th>Valor Sem Descontos</th>
                    </tr>
                    </thead>
                    <tbody>
                    <tr v-for="(parcelas, indice) in parcelaSelecionada.detalhes" :key="indice">
                        <td>{{indice + 1}}</td>
                        <td>{{parcelas.dataVencimento | dateEnToBr}}</td>
                        <td>R$ {{parcelas.valorUnitario | currencyEnToBr}}</td>
                        <td>R$ {{parcelas.valorSemDesconto | currencyEnToBr}}</td>
                    </tr>
                    </tbody>
                </table>
            </v-flex>
        </v-layout>
        <div class="flex-header">
            <navigation-buttons
              :show-previous="true"
              :show-next="true"
              :disable-next="$v.dadosMatricula.$invalid"
              :previous-click="voltar"
              :next-click="salvarDados"
              >
            </navigation-buttons>
        </div>
    </v-container>
</template>

<style>
    .radio-financeiro .v-radio {
        padding: 10px 0;
    }
</style>



// WEBPACK FOOTER //
// Financeiro.vue?276c633f